import React from 'react';

const AdminImagePreviewModal = ({ imageUrl, onCancel }) => {
    // This allows closing the modal by clicking the background overlay
    const handleOverlayClick = () => {
        onCancel();
    };

    // This prevents the modal from closing when the image itself is clicked
    const handleContentClick = (e) => {
        e.stopPropagation();
    };

    return (
        <div className="admin-modal-overlay" onClick={handleOverlayClick}>
            <div className="image-preview-modal-content" onClick={handleContentClick}>
                <img src={imageUrl} alt="Preview" className="image-preview-modal-image" />
            </div>
            <button onClick={onCancel} className="image-preview-close-btn">&times;</button>
        </div>
    );
};

export default AdminImagePreviewModal;